'use client'

const ignoredErrorMessages = [
  'ResizeObserver loop limit exceeded',
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
]

const browserStateKey = Symbol.for('gridfinder.new-relic.browser-state')

function getBrowserState() {
  if (typeof window === 'undefined') return null

  // instrumentation-client and React's error boundary can have separate module
  // instances in a production build. Share the agent and early-error queue
  // within this document, without putting mutable state into the SSR runtime.
  return (window[browserStateKey] ||= { agent: null, pendingErrors: [] })
}

export function shouldIgnoreBrowserError(error) {
  const message =
    typeof error === 'string'
      ? error
      : typeof error?.message === 'string'
        ? error.message
        : ''

  return (
    ignoredErrorMessages.some((ignored) => message.includes(ignored)) ||
    /Warning:/i.test(message)
  )
}

export function setNewRelicBrowserAgent(agent) {
  const state = getBrowserState()
  if (!state) return
  state.agent = agent

  while (state.pendingErrors.length > 0) {
    const [error, attributes] = state.pendingErrors.shift()
    agent?.noticeError?.(error, attributes)
  }
}

export function reportBrowserError(error, attributes = {}) {
  try {
    if (shouldIgnoreBrowserError(error)) return

    const state = getBrowserState()
    if (!state) return
    const agent = state.agent || window.newrelic
    if (agent?.noticeError) {
      agent.noticeError(error, attributes)
      return
    }

    // An error boundary can run while client instrumentation is still
    // initializing. Keep a small bounded queue and flush it when ready.
    if (state.pendingErrors.length < 20) {
      state.pendingErrors.push([error, attributes])
    }
  } catch {
    // Error reporting must never break an error boundary.
  }
}
